'use strict';

var formValidation = require('base:components/formValidation');
let $cache = {
    form: $('#rxForm'),
    cardNumberInput: $('#dwfrm_rxForm_cardNumber')
};

/**
 * Clear error message
 */
function clearErrorMessage() {
    $('.rx-error-message .alert-danger').addClass('d-none');
    $('.rx-error-message:visible .alert-danger .error-message-text').html('');
}
/**
 * Show error message
 * @param {any} e - error
 */
function showErrorMessage(e) {
    $('.rx-error-message:visible .alert-danger').removeClass('d-none');
    $('.rx-error-message:visible .alert-danger .error-message-text').html(e);
}

/**
 * verify form entries of section 0
 * @returns {Promise} promise
 */
function verifySection0() {
    return new Promise((resolve, reject) => {
        $.spinner().start();
        var button = $('.btn-submit-rx-voucher-form');

        window.dataLayer.push({
            event: 'Etape0'
        });

        button.attr('disabled', true);
        $.ajax({
            method: 'POST',
            url: $cache.form.attr('data-voucher-submit'),
            data: $cache.form.serialize(),
            success: function (data) {
                if (!data.success) {
                    formValidation($cache.form, data);
                    reject(data.errorMsg);
                    button.removeAttr('disabled');
                    $.spinner().stop();
                } else {
                    resolve(data);
                    button.removeAttr('disabled');
                    $.spinner().stop();
                }
            },
            error: function (err) {
                reject(err);
                button.removeAttr('disabled');
                $.spinner().stop();
            }
        });
    });
}

module.exports = {
    init: function () {
        window.dataLayer = window.dataLayer || [];
        $('.js-next-btn').on('click', async function () {
            try {
                clearErrorMessage();
                let response = await verifySection0();

                if (response.nextStepUrl) {
                    window.location.href = response.nextStepUrl;
                }
            } catch (e) {
                if (e && e.length > 0) {
                    showErrorMessage(e);
                }
            }
        });
        $($cache.form).on('keypress', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                $('.js-next-btn:visible', $cache.sections).trigger('click');
            }
        });

        $cache.cardNumberInput.on('keyup', function (event) {
            // When user select text in the document, also abort.
            var selection = window.getSelection().toString();
            if (selection !== '') {
                return;
            }
            // When the arrow keys are pressed, abort.
            if ($.inArray(event.keyCode, [38, 40, 37, 39]) !== -1) {
                return;
            }
            var $this = $(this);
            var hasHitDelete = event.keyCode === 8 || event.keyCode === 46;
            var lastCharIsSpace = $this.val().substr(-1) === ' ' && !hasHitDelete;
            var input = $this.val().replace(/[^a-z0-9]/gi, '');
            var charsPerGroup = 3;
            var nbGroups = 4;
            var chunk = [];

            for (var i = 0, len = input.length; i < len && i < nbGroups * charsPerGroup; i += charsPerGroup) {
                chunk.push(input.substr(i, charsPerGroup));
            }
            $this.val(function () {
                return chunk.join(' ').toUpperCase() + (lastCharIsSpace ? ' ' : '');
            });
        });
    }
};
